import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';
import { injectIntl, intlShape } from 'react-intl';

import styles from './index.css';

const TestableSpan = testable(QA_MALT, 'span');

export const TYPE_BETA = 'BETA';
export const TYPE_PROMO = 'PROMO';
export const TYPE_PREMIUM = 'PREMIUM';
export const TYPE_NEWS_PLUS = 'NEWSPLUS';
export const TYPE_PROJOBS = 'PROJOBS';
export const TYPE_PROCOACH = 'PROCOACH';
export const TYPE_EXECUTIVE = 'EXECUTIVE';

const flagTypes = [
  TYPE_BETA,
  TYPE_PROMO,
  TYPE_PREMIUM,
  TYPE_NEWS_PLUS,
  TYPE_PROJOBS,
  TYPE_PROCOACH,
  TYPE_EXECUTIVE,
];

const label = {
  [TYPE_BETA]: 'Beta',
  [TYPE_PREMIUM]: 'Premium',
  [TYPE_PROMO]: 'VERTICAL_NAVIGATION_NEW',
  [TYPE_NEWS_PLUS]: 'News Plus',
  [TYPE_PROJOBS]: 'Jobs',
  [TYPE_PROCOACH]: 'Coach',
  [TYPE_EXECUTIVE]: 'Executive',
};

const Flag = ({
  type = undefined,
  className = undefined,
  testId = undefined,
  hasPaid = undefined,
  small = undefined,
  intl: { formatMessage },
}) => {
  const isFilled = [TYPE_PROMO, TYPE_BETA].includes(type);
  const isProProduct = [TYPE_PROCOACH, TYPE_PROJOBS].includes(type);
  const isPremiumOrProProduct = type === TYPE_PREMIUM || isProProduct;
  const isExecutiveProduct = type === TYPE_EXECUTIVE;
  const badgeText =
    type === TYPE_PROMO ? formatMessage({ id: label[type] }) : label[type];
  const typeClass = styles[type.toLowerCase()];
  return (
    <TestableSpan
      className={classNames(
        {
          [styles.contentFlagFenced]: !hasPaid && !isFilled,
          [styles.contentFlagPaidPremiumOrPro]:
            hasPaid && isPremiumOrProProduct,
          [styles.contentFlagExecutive]: hasPaid && isExecutiveProduct,
          [styles.contentFlagSmall]: small,
        },
        typeClass,
        className
      )}
      testId={testId}
    >
      {isProProduct && (
        <span
          className={classNames(
            hasPaid ? styles.proLabelPaid : styles.proLabelFenced
          )}
        >
          Pro
        </span>
      )}
      <span className={styles.text}>{badgeText}</span>
    </TestableSpan>
  );
};

Flag.propTypes = {
  /** define the type of flag that should be shown – changes the styling accordingly. */
  type: PropTypes.oneOf(flagTypes).isRequired,
  /** add a custom className to the component */
  className: PropTypes.string,
  /** define a testid for the flag */
  testId: PropTypes.string,
  /** if a product has been paid for, this is the prop you want to set to `true` */
  hasPaid: PropTypes.bool,
  /** set this to render a small version */
  small: PropTypes.bool,
  /** @private **/
  intl: intlShape,
};

Flag.displayName = 'Flag';

export default injectIntl(Flag);
